module.exports = __webpack_public_path__ + "static/media/arrows-v.67468c01.svg";